import React from "react";
import Card from "@mui/material/Card";
import Footer from "../../../components/Footer";
import MDBox from "../../../components/MDBox";
import DashboardNavbar from "../../../components/Navbars/DashboardNavbar";
import DashboardLayout from "../../../components/LayoutContainers/DashboardLayout";
import DataTable from "../../../components/DataTable/DataTable";
import {API_URL, COLOR_SECONDARY} from "../../../config";
import usePatients from "./usePatients";
import {NavLink} from "react-router-dom";
import moment from "moment/moment";
import DateFilter from "../../../components/DateFilter/DateFilter";

const Patients = () => {
    const {actions, filters, renderStatusChip, roleId} = usePatients();

    return (
        <DashboardLayout>
            <DashboardNavbar/>
            <MDBox pt={2} pb={3}>
                <MDBox mb={3}>
                    <Card>
                        <DataTable
                            endpoint={`${API_URL}/patients`}
                            title="Pacientes"
                            description="Administrar los pacientes."
                            sortBy="name"
                            sortDirection="asc"
                            filter={true}
                            actions={actions}
                            colData={[
                                {
                                    name: 'id',
                                    label: 'ID',
                                    options: {
                                        display: 'excluded',
                                        filter: false
                                    }
                                },
                                {
                                    name: 'name',
                                    label: 'Nombre',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => (
                                            <NavLink to={`/pacientes/${tableMeta.rowData[0]}`}
                                                     key={`paciente-${tableMeta.rowData[0]}`}
                                                     style={{fontWeight: 500, color: COLOR_SECONDARY, textDecoration: 'underline'}}
                                            >
                                                {value} {tableMeta.rowData[2]} {tableMeta.rowData[3]}
                                            </NavLink>
                                        )
                                    }
                                },
                                {
                                    name: 'last_name',
                                    label: 'Apellido',
                                    options: {
                                        display: 'excluded'
                                    }
                                },
                                {
                                    name: 'mother_last_name',
                                    label: 'Apellido Materno',
                                    options: {
                                        display: 'excluded'
                                    }
                                },
                                {
                                    name: 'email',
                                    label: 'Correo',
                                },
                                {
                                    name: 'phone',
                                    label: 'Teléfono',
                                },
                                {
                                    name: 'created_at',
                                    label: 'Fecha',
                                    options: {
                                        filterType: 'custom',
                                        customFilterListOptions: {
                                            render: v => {
                                                if (v[0] && v[1]) return `Fecha: ${moment(v[0]).format('YYYY-MM-DD')} - ${moment(v[1]).format('YYYY-MM-DD')}`;
                                                if (v[0]) return `Desde: ${moment(v[0]).format('YYYY-MM-DD')}`;
                                                if (v[1]) return `Hasta: ${moment(v[1]).format('YYYY-MM-DD')}`;
                                                return false;
                                            },
                                            update: (filterList, filterPos, index) => {
                                                if (filterPos === 0) filterList[index].splice(filterPos, 1, '');
                                                else filterList[index] = [];
                                                return filterList;
                                            }
                                        },
                                        filterOptions: {
                                            names: [],
                                            display: (filterList, onChange, index, column) => <DateFilter filterList={filterList} column={column} onChange={onChange} index={index} />
                                        }
                                    }
                                },
                            ]}
                        />
                    </Card>
                </MDBox>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default Patients;
